module.exports = __webpack_public_path__ + "img/sign-5.99ce8290.jpg";